import { useState } from 'react';

// Manages add/edit/delete form state for list-based editors.
// Reduces the repeated showForm / editingIndex / formData pattern across scene components.
export const useListForm = (initialData) => {
  const [showForm, setShowForm] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [formData, setFormData] = useState(initialData);

  const openAdd = () => {
    setFormData(initialData);
    setEditingIndex(null);
    setShowForm(true);
  };

  const openEdit = (item, index) => {
    setFormData({ ...item });
    setEditingIndex(index);
    setShowForm(true);
  };

  const close = () => {
    setShowForm(false);
    setEditingIndex(null);
    setFormData(initialData);
  };

  return { showForm, editingIndex, formData, setFormData, openAdd, openEdit, close };
};
